// extracted by mini-css-extract-plugin
export default {"page":"layout-main_page__NCVCJ","pageMarginForPopUp":"layout-main_pageMarginForPopUp__igwbp","outlet":"layout-main_outlet__du-Fq"};